import { put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import * as actions from '../store/options.actions'
import { getNeuroSelector } from '../../initialAssessments/neuro/selectors'
import { getNeuroOptionsSelector } from '../selectors'
import { INeuroOptionsState } from '../store/options.types'
import { NeuroConstants } from '../../initialAssessments/neuro/store/neuro.constants'
import { INeuroState } from '../../initialAssessments/neuro/store/neuro.types'
import {
  buildCustomStrokeScaleScoreOptions,
  getAllowedStrokeScoreIds,
  IStrokeScaleConfigOption,
  IStrokeScaleScoreOption,
} from '../../initialAssessments/neuro/strokeScore/utils/strokeScaleScore.util'

export function* setNeuroCustomStrokeScoreScaleOptions() {
  try {
    const neuroData: INeuroState = yield select(getNeuroSelector)
    const neuroOptionsData: INeuroOptionsState = yield select(getNeuroOptionsSelector)
    const { strokeScale } = neuroData
    const { strokeScaleScoreOptions, strokeScaleConfigOptions } = neuroOptionsData

    if (strokeScale?.id) {
      const allowedScoreIds = getAllowedStrokeScoreIds(
        strokeScale.id,
        strokeScaleConfigOptions as IStrokeScaleConfigOption[]
      )
      const entity = buildCustomStrokeScaleScoreOptions(
        strokeScaleScoreOptions as IStrokeScaleScoreOption[],
        allowedScoreIds
      )
      yield put(actions.setNeuroCustomStrokeScoreScaleOptions(entity))
    }
  } catch (e) {
    yield put(throwPcrException(`setNeuroCustomStrokeScoreScaleOptions() error: ${e}`))
  }
}
export function* setNeuroCustomStrokeScoreScaleOptionsSaga() {
  yield takeLatest([NeuroConstants.SET_STROKESCALE, NeuroConstants.SET_NEURO], setNeuroCustomStrokeScoreScaleOptions)
}
